import React from 'react'
import HotelPreview from './components/HotelReview/HotelPreview'
import { useParams } from 'react-router-dom';

const HotelSingle = () => {
    let { id } = useParams();
    return (
        <HotelPreview id={id} />
    )
}

export default HotelSingle